import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoEsquemasAgregarComponent {
  idProyecto = undefined
  guardando = false
  error = null
  data = {
    comision_porcentaje: 0,
    comisionistas: [],
    id_metodo_calculo_comision: undefined,
    id_metodo_calculo_suministro: undefined,
    id_tipo_comision: undefined,
    limite_suministro: 0,
    nombre: '',
    predeterminado: false,
    impuestos: [],
  }

  constructor (FanProyectoEsquemasService, $state) {
    this.FanProyectoEsquemasService = FanProyectoEsquemasService
    this.$state = $state
  }

  agregar () {
    if (this.guardando) return

    this.guardando = true
    this.error = null

    const data = {
      ...this.data,
      comisionistas: this.data.id_tipo_comision === 0 ? [] : this.data.comisionistas,
    }

    return this.FanProyectoEsquemasService.post(this.idProyecto, data)
      .then(() => (this.$state.go('^', {reload: true})))
      .catch((response) => (this.error = response.error))
      .finally(() => (this.guardando = false))
  }
}

module.component('fanProyectoEsquemasAgregar', {
  controller: FanProyectoEsquemasAgregarComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/agregar/component.js